import { Cookies } from 'react-cookie';
import axios, { AxiosError } from 'axios';
import Configs from 'config';
import { handleHTTPError } from 'libs/api/errorHandle';

export const CCSRFToken = 'bigstep_csrftoken';
export const CSAUTHID = 'bigstep_authid';
export const CSTEMPUSERID = 'bigstep_tempuserid';
export const CSAUTHToken = 'bigstep_authtoken';
export const KAITUSTimerToken = 'kaitus_timertoken';
export const cookies = new Cookies();
export const host = Configs.API_HOST;
const apiClient = axios.create({
  baseURL: host,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRFToken': window.localStorage.getItem(CCSRFToken),
  },
  responseType: 'json',
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    return handleHTTPError(error as AxiosError);
  },
);

export const makeQueryString = (variable: any): string => {
  let querystring: string[] = [];
  if (variable) {
    Object.keys(variable).forEach((key: string) => {
      if (variable[key] !== undefined && variable[key] !== null) {
        querystring.push(`${key}=${variable[key]}`);
      }
    });
  }
  return querystring.join('&');
};

export const WrappingApiClient = async (promise: any) => {
  try {
    const response = await promise;
    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    // showAlert(undefined, "에러가 발생하였습니다.", error.message);
    return {
      success: false,
      error,
    };
  }
};

export default apiClient;
